export const analyzeData = (data) => {
  if (!data?.length) return null;

  const columns = Object.keys(data[0]);

  return {
    rows: data.length,
    columns,
    columnCount: columns.length,
  };
};